import { createContext, useContext } from 'react'

import { StoreProgramResponse } from '../../services/storeProgramService'

export interface StorefrontModeContextState {
  isB2BMode: boolean
  storeProgramResponse?: StoreProgramResponse
}

export const StorefrontModeContext = createContext<StorefrontModeContextState>({
  isB2BMode: false,
})

export const useStorefrontModeContext = () => {
  const context = useContext(StorefrontModeContext)

  return context
}
